// models/tree-node.ts
import {DcPageTypeDto} from "./dc-page-type.dto";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export interface DcTreeNode<T> {
    data: T;
    children: DcTreeNode<T>[];
}

// models/dc-page-dto-detail.ts
export class DcPageDto extends DtoDetail {
    id: number;
    level: number;
    parentDtoId?: number;
    title: string;
    icon: string;
    pageType: DcPageTypeDto;
}
